import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import COLORS from '../../../resources/style/Themes';
import Marquee from 'react-fast-marquee';
import { useBannerHeight } from '../../../context_providers/banner_context/BannerHeightContext';
import { useUserContext } from '../../../context_providers/user_context/UserProvider';
import { StringKeys } from '../../../resources/strings/StringKeys';

const DevelopmentEnvironmentBanner = () => {
  const { t } = useTranslation();
  const devEnv = import.meta.env.VITE_COMPASS_PRO_ENV;
  const { emergencyBannerHeight, updateDevelopmentBannerHeight } =
    useBannerHeight();
  const { safeguardView } = useUserContext();
  const topPlacement =
    safeguardView || emergencyBannerHeight === 0 ? '65px' : '97px';

  const isBeta = devEnv === 'beta';
  const isDev = devEnv === 'dev';

  useEffect(() => {
    if (isDev || isBeta) updateDevelopmentBannerHeight(30);
  }, [isDev, isBeta, updateDevelopmentBannerHeight]);

  if (!isDev && !isBeta) return null;

  const bannerBackground = isBeta ? COLORS.BETA_BANNER_COLOR : 'green';
  const bannerText = isBeta
    ? t(StringKeys.BETA_ENVIRONMENT_BANNER)
    : 'Connected to development environment. Good luck, have fun!';

  return (
    <div
      style={{
        top: topPlacement,
        height: '32px',
        textAlign: 'center',
        position: 'fixed',
        color: COLORS.WHITE,
        width: '100%',
        fontWeight: 'bold',
        zIndex: 100,
        fontSize: '16px',
        background: bannerBackground,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Marquee gradient={false} speed={50} style={{ width: '100%' }}>
        {bannerText}
      </Marquee>
    </div>
  );
};

export default DevelopmentEnvironmentBanner;
